export const COLORS = ['grey', 'darkGrey', 'lightCyan', 'cyan', 'yellow'];
export const VARIANTS = ['rounded', 'flatRight', 'flatLeft'];
